<template>
  <div>
    <el-menu
      router
      unique-opened
      :default-active="defaultPatch"
      @select="select"
      background-color="#ffffff"
      text-color="#000"
      active-text-color="#409eff"
    >
      <el-submenu
        v-for="(item,index) in authList"
        :key="index"
        :index="item.path"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{item.name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            v-for="(item2,index2) in item.children"
            :key="index2"
            :index="item2.path"
          >{{item2.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {

    }
  },
  methods: {
    ...mapMutations('role', ['changedefaultPatch', 'changetabs']),
    select (e, a, b) {
      this.changedefaultPatch(e) // 设置激活菜单  避免刷新无选中
      // // 设置tabs标签 不重复的情况下添加标签页
      let num = 0
      let arr = this.tabs
      arr.forEach(item => {
        if (item.path == e) {
          num++
        }
      })
      if (num == 0) {
        this.authList.forEach(item => {
          item.children.forEach(item2 => {
            if (item2.path == a[1]) {
              arr.push({
                name: item2.name,
                path: a[1]
              })
            }
          })
        })
      }
      sessionStorage.setItem('tabsList', JSON.stringify(arr));
    }
  },
  created () {

    console.log(this.roleList);
  },
  watch: {
    defaultPatch (a, b) {
      this.changedefaultPatch(a)
    }
  },
  computed: {
    ...mapState('role', ['authList', 'defaultPatch', 'tabs']),
  }
}
</script>

<style lang="scss" scoped>
/* 文字 */

::v-deep.el-submenu.is-active > .el-submenu__title {
  background: #409eff !important;
  color: #ffffff !important;
}
/* icon图标也跟着变 */
::v-deep .el-submenu.is-active > .el-submenu__title i {
  background: #409eff !important;
  color: #ffffff !important;
}
::v-deep.el-menu {
  border-right: 0;
}
</style>